import React, { Component } from "react";
import { Row, Col, Badge, Avatar , Icon } from "antd";

export const Header = props => {
  return (
    <header>
      <img
        src="https://www.integration-x.com/wp-content/uploads/sites/9/2016/03/X-superior-blue.png"
        alt="logo"
      />
      <Row>
        <Col span={20}>
          <h4>Control Panel </h4>
        </Col>
        <Col span={3} className="text-right">
        </Col>
        <Col span={1} className="text-right">
          <Avatar size="small" shape="circle" icon="user" />
        </Col>
      </Row>
    </header>
  );
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Header/HeaderComponent.js